module.exports = new __parcel__URL__("Packing_Slip.4bdd0f9b.png").toString();